import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../ui_kit/select/Select';

function Variants(props) {
  const {
    selectVariant, variants, selectedVariantId, variantsSelectText,
  } = props;

  return (
    <Select
      id="variants-select"
      options={variants.map((variant) => ({ label: variant.name, value: variant.id }))}
      defaultOption={<option disabled value="default">{variantsSelectText || 'Choose'}</option>}
      value={selectedVariantId || 'default'}
      onChange={(event) => { selectVariant(Number(event.target.value)); }}
    />
  );
}

Variants.propTypes = {
  selectVariant: PropTypes.func.isRequired,
  variants: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  })).isRequired,
  selectedVariantId: PropTypes.number,
  variantsSelectText: PropTypes.string,
};

export default Variants;
